var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-body"},[_c('div',{staticClass:"container-main"},[_c('WorkRegistrationForm',{attrs:{"workDate":_vm.workDate,"drivers":_vm.drivers}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }